import { Image } from 'lucide-react';

import type { AnimeSubject } from '../types/bgm';
import { safeUrl } from '../utils/url';
import { useApp } from './app-context';

export const AnimeCard = ({ subject }: { subject: AnimeSubject }) => {
  const { navigate } = useApp();
  const title = subject.name_cn || subject.name;
  const image = safeUrl(subject.images?.large ?? subject.images?.common ?? subject.images?.medium);
  const score = subject.score ?? subject.rating?.score;
  return (
    <a
      className="group min-w-0 text-inherit no-underline"
      href={`/subjects/${subject.id}`}
      onClick={(event) => {
        event.preventDefault();
        navigate(`/subjects/${subject.id}`);
      }}
    >
      <div className="relative grid aspect-[3/4.2] place-items-center overflow-hidden rounded-[11px] bg-(--surface-2) text-(--muted)">
        {image ? (
          <img
            className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.035]"
            src={image}
            alt=""
            loading="lazy"
            referrerPolicy="no-referrer"
          />
        ) : (
          <Image className="w-6" />
        )}
        {score ? (
          <span className="absolute right-1.75 bottom-1.75 rounded-md bg-[rgba(10,12,16,0.78)] px-1.75 py-1 text-[9px] font-extrabold text-white backdrop-blur-lg">
            ★ {score.toFixed(1)}
          </span>
        ) : null}
      </div>
      <h3 className="mt-2.5 overflow-hidden text-ellipsis whitespace-nowrap text-xs">{title}</h3>
      {subject.name_cn && subject.name ? (
        <p className="mt-1 overflow-hidden text-ellipsis whitespace-nowrap text-[9px] text-(--muted)">{subject.name}</p>
      ) : null}
    </a>
  );
};
